import { Injectable } from '@angular/core';
import {environment} from '../../environments/environment';
import {TranslateService} from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class TranslationSelectorService {
  private languageLocalStorageKey = environment.defaultLanguage === 'uk' ? 'lang' : 'language';
  constructor(
    private translateService: TranslateService
  ) { }

  public getAvailableLanguages(): string[] {
    return environment.supportedLanguages;
  }

  public setLanguage(language: string) {
    localStorage.setItem(this.languageLocalStorageKey, language);
    location.reload();
  }

  private getLocalStorageLanguage() {
    let localStorageLang = localStorage.getItem(this.languageLocalStorageKey);
    if (localStorageLang === 'ua') {
      localStorageLang = 'uk';
      localStorage.setItem(this.languageLocalStorageKey, localStorageLang);
    }
    return localStorageLang;
  }

  private validateLanguage(language: string): boolean {
    return environment.supportedLanguages.includes(language);
  }

  public getSelectedLanguage(): string {
    const browserLanguage = this.translateService.getBrowserLang();
    const localStorageLanguage = this.getLocalStorageLanguage();
    if (this.validateLanguage(localStorageLanguage)) {
      return localStorageLanguage;
    }
    if (this.validateLanguage(browserLanguage)) {
      return browserLanguage;
    }
    return environment.defaultLanguage;
  }
}
